import Papa from 'papaparse'

/**
 * CSV text → `string[][]`, bez interpretace hlavičky.
 *
 * `header: false` je záměr: hlavičku detekujeme sami (detectHeader), protože
 * papaparse by při `header: true` u bezhlavičkového souboru snědlo první datový
 * řádek jako názvy sloupců.
 *
 * `delimiter: ''` zapíná autodetekci — český Excel exportuje se středníkem, ne
 * čárkou.
 */
export function readCsv(text: string, forcedDelimiter?: string): { rows: string[][]; delimiter: string } {
    const result = Papa.parse<string[]>(text, {
        header: false,
        skipEmptyLines: 'greedy',
        delimiter: forcedDelimiter ?? '',
        delimitersToGuess: [',', ';', '\t', '|']
    })

    const rows = (result.data ?? []).map(r => r.map(cell => (cell ?? '').trim()))

    return {
        rows: normaliseWidth(rows),
        delimiter: result.meta?.delimiter ?? forcedDelimiter ?? ','
    }
}

/**
 * Doplní kratší řádky prázdnými buňkami na šířku nejdelšího.
 *
 * Ragged CSV je běžné (tabulkové editory neukládají trailing prázdné buňky) a
 * mapování by jinak sahalo mimo pole.
 */
function normaliseWidth(rows: string[][]): string[][] {
    const width = rows.reduce((max, r) => Math.max(max, r.length), 0)
    return rows.map(r => (r.length === width ? r : [...r, ...Array(width - r.length).fill('')]))
}
